webpackJsonp([195850678278728],{

/***/ 979:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.query = undefined;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _withStyles = __webpack_require__(5);
	
	var _withStyles2 = _interopRequireDefault(_withStyles);
	
	var _Chip = __webpack_require__(768);
	
	var _Chip2 = _interopRequireDefault(_Chip);
	
	var _Meta = __webpack_require__(48);
	
	var _kebabCase = __webpack_require__(712);
	
	var _kebabCase2 = _interopRequireDefault(_kebabCase);
	
	var _goToUrl = __webpack_require__(289);
	
	var _goToUrl2 = _interopRequireDefault(_goToUrl);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var styles = function styles(theme) {
	  return {
	    root: {
	      minHeight: '90vh',
	      display: 'flex',
	      justifyContent: 'center',
	      alignItems: 'center'
	    },
	    tag: {
	      background: theme.palette.primary.main,
	      color: '#fff',
	      cursor: 'pointer',
	      margin: theme.spacing.unit / 4,
	      '&:hover': {
	        background: theme.palette.accent.gray
	      }
	    }
	  };
	};
	
	var TagsPage = function TagsPage(_ref) {
	  var classes = _ref.classes,
	      data = _ref.data;
	
	  var tags = data.allMarkdownRemark.group;
	  var siteMetadata = data.site.siteMetadata;
	
	
	  return _react2.default.createElement(
	    'div',
	    { className: classes.root },
	    _react2.default.createElement(_Meta.RootMeta, {
	      title: 'Tags | ' + siteMetadata.siteName,
	      url: siteMetadata.siteUrl,
	      description: siteMetadata.siteDescription
	    }),
	    _react2.default.createElement(
	      'div',
	      { style: { textAlign: 'center' } },
	      tags.map(function (_ref2, i) {
	        var fieldValue = _ref2.fieldValue,
	            totalCount = _ref2.totalCount;
	
	        return _react2.default.createElement(_Chip2.default, {
	          key: 'tag' + i + fieldValue,
	          onClick: (0, _goToUrl2.default)('/tags/' + (0, _kebabCase2.default)(fieldValue)),
	          className: classes.tag,
	          size: 'small',
	          label: _react2.default.createElement(
	            _react2.default.Fragment,
	            null,
	            fieldValue,
	            ' ',
	            _react2.default.createElement(
	              'span',
	              { style: { paddingLeft: 10, opacity: 0.6 } },
	              totalCount
	            )
	          )
	        });
	      })
	    )
	  );
	};
	
	TagsPage.propTypes = {
	  classes: _propTypes2.default.object.isRequired,
	  data: _propTypes2.default.object.isRequired
	
	  // eslint-disable-next-line
	};var query = exports.query = '** extracted graphql fragment **';
	
	exports.default = (0, _withStyles2.default)(styles)(TagsPage);

/***/ }),

/***/ 289:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _gatsbyLink = __webpack_require__(28);
	
	function goToUrl(url) {
	  return function () {
	    if (/^http/.test(url)) {
	      // eslint-disable-next-line
	      return window.open(url, '_blank');
	    }
	    return (0, _gatsbyLink.navigateTo)(url);
	  };
	}
	
	exports.default = goToUrl;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-tags-js-0744635ba9316a23600e.js